<template>
  <div
    class="container max-w-md p-6 mx-auto overflow-hidden font-mono text-teal-100 transition duration-200 ease-in-out transform bg-no-repeat shadow-2xl cursor-pointer rounded-credential-card-header hover:scale-105"
    :style="`background-image: url(${require('../assets/fondo.png')})`"
    v-on="$listeners"
  >
    <div class="flex items-center justify-between">
      <img class="h-12" :src="require('../assets/logo.png')" />
      <span class="text-3xl font-bold tracking-widest">{{ nroCredencial }}</span>
    </div>

    <div class="mt-2">
      <span class="text-xl font-semibold tracking-wider uppercase">
        {{ nombreCompleto }}
      </span>
    </div>
  </div>
</template>

<script>
import credentialProps from '@/mixins/credentialProps'

export default {
  props: {
    credencial: { type: Object, required: true },
  },

  mixins: [credentialProps],
}
</script>

<style>
.rounded-credential-card-header {
  border-top-left-radius: 2.25rem;
  border-top-right-radius: 2.25rem;
}
</style>
